import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { useLocation } from "react-router";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
import { Accordion, AccordionTab } from "primereact/accordion";
//components
import Panel from "../../../components/panel/panel";
import Switch from "../../../components/input/Switch";
//services
import { getRegistrationPermission } from "../../../services/GlobalRoles/getRegistrationPermission";
import { postRegistrationPermission } from "../../../services/GlobalRoles/postRegistrationPermission";
import usePermission from "../../../hooks/usePermission";
import { useAppContext } from "../../../context/AppContext";




const EditTypesRegistration = () => {
  usePermission("134"); // Editar tipos de Cadastros por Grupo de Acesso
  const { permissions } = useAppContext();
  const { state } = useLocation();
  const rowData = state.rowData;



  const items = [
    {
      template: () => (
        <Link to={`/settings/accessGroups`} className="p-breadcrumb-link">
          {rowData.name}
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/settings/accessGroups/seeEdit`}
          state={{ rowData }}
          className="p-breadcrumb-link"
        >
          Permissão Tipo de Cadastro
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/settings/accessGroups"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const {
    control,
    handleSubmit: handleSubmitRoles,

    formState: { errors },
  } = useForm({});

  const [loading, setLoading] = useState(true);
  const [checkedStates, setCheckedStates] = useState({});

  var idRole = rowData.id;


  const { data: registrationPermission, refetch, isLoading } = useQuery(
    ["registrationPermission"],
    () => getRegistrationPermission(idRole),
    {
      onSuccess: (data) => {
        setLoading(false);
        setCheckedStates(data);
      },
      enabled: !!permissions?.includes("134")
    }
  );


  const handleSwitchToggle = (name, isChecked) => {
    setCheckedStates((prevStates) => ({
      ...prevStates,
      [name]: isChecked,
    }));
  };

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };


  const mergePermissions = (data, registrationPermission) => {
    const merged = {
      role_id: idRole, // Pode ser setado conforme a lógica do seu sistema
      access: [],
      registration_types: [],
    };
    console.log(registrationPermission)

    // Itera sobre o objeto de permissões (roles)
    for (const role of registrationPermission?.roles) {
      const roleKey = `role-${role.id}`;

      // Se o campo estiver como true no data ou se no estado original ele era true
      if (data[roleKey] === true || (data[roleKey] === undefined && role?.enable)) {
        merged.access.push(role.id);
      }
    }

    // Itera sobre o objeto de registration_types
    for (const type of registrationPermission.registration_types) {
      const typeKey = `type-${type.id}`;

      // Se o campo estiver como true no data ou se no estado original ele era true
      if (data[typeKey] === true || (data[typeKey] === undefined && type.enable)) {
        merged.registration_types.push(type.id);
      }
    }

    return merged;
  };


  const sendSubmitRoles = async (data) => {
    console.log(data);
    console.log(checkedStates);

    const notification = toast.loading("Aguarde, Alterando Permissões...");
    // Função assíncrona que faz a mesclagem das permissões
    const mergedResult = await mergePermissions(data, checkedStates);

    // Verifica se os arrays estão vazios
    if (mergedResult.access.length <= 0 && mergedResult.registration_types.length <= 0) {
      toast.update(notification, {
        render: "Preencha ao menos um Tipo de Cadastro / Acesso!",
        autoClose: 5000,
        type: "warning",
        isLoading: false,
      });
      return;  // Retorna caso não tenha preenchido os requisitos
    }

    console.log(mergedResult);
    try {
      setLoading(true);

      // Função assíncrona que envia as permissões
      await postRegistrationPermission(mergedResult);
      await refetch();
      // Atualiza o toast com sucesso
      toast.update(notification, {
        render: "Permissões Alteradas com Sucesso!",
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });


    } catch (error) {
      console.log(error);

      // Atualiza o toast com erro
      toast.update(notification, {
        render: "Não foi Possível Alterar as Permissões!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
    } finally {
      // O refetch será feito sempre, independentemente do resultado
      refetch();
      setLoading(false); // Sempre desabilita o loading
    }
  };






  const MeuBotao = ({ loading }) => (
    <div className="pt-5 text-center">
      <Button
        disabled={isLoading}
        type="submit"
        rounded
        label="Salvar"
        icon="fa fa-plus"
        className="p-inputtext-sm m-auto"
        loading={loading}
      />
    </div>
  );



  return (
    <>
      <div className="col-xl-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>

      {loading && (
        <div className="col-md-12">
          <div className="card flex rounded-4 px-4">
            <div className="flex mb-5">
              <div className="py-3">
                <Skeleton width="75%" height="2rem"></Skeleton>
              </div>
            </div>
            <div className="pb-2">
              <Skeleton width="100%" height="50px"></Skeleton>
            </div>
          </div>
        </div>
      )}
      <form onSubmit={handleSubmitRoles(sendSubmitRoles)}>
        {!loading && (
          <Panel title="Permissão de Tipos de Cadastro">
            <div className="p-5">
              <Accordion>
                <AccordionTab header={<span>Acessos</span>}>
                  <div className="d-flex flex-wrap border p-3 shadow-sm" style={{ borderRadius: "8px" }}>
                    {registrationPermission.roles.map((role) => (
                      <div key={role.id} className="col-md-3 text-wrap d-flex align-items-stretch">
                        <div className="text-center pb-2 flex-grow-1"
                          style={{
                            borderBottom: "1px solid #eee",
                            marginBottom: "10px",
                            minHeight: "100px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center"
                          }}
                        >
                          <p className="text-break mb-2">{role.name}</p>
                          <div className="d-flex justify-content-center">
                            <Switch
                              name={`role-${role.id}`}
                              control={control}
                              getFormErrorMessage={getFormErrorMessage}
                              checked={role.enable}
                              onToggle={(isChecked) => handleSwitchToggle(role.id, isChecked)}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </AccordionTab>


                <AccordionTab header={<span>Tipos de Cadastro</span>}>
                  <div className="d-flex flex-wrap border p-3 shadow-sm" style={{ borderRadius: "8px" }}>
                    {registrationPermission.registration_types.map((type) => (
                      <div key={type.id} className="col-md-3 text-wrap d-flex align-items-stretch">
                        <div className="text-center pb-2 flex-grow-1"
                          style={{
                            borderBottom: "1px solid #eee",
                            marginBottom: "10px",
                            minHeight: "100px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center"
                          }}
                        >
                          <p className="text-break mb-2">{type.name}</p>
                          <div className="d-flex justify-content-center">
                            <Switch
                              name={`type-${type.id}`}
                              control={control}
                              getFormErrorMessage={getFormErrorMessage}
                              checked={type.enable}
                              onToggle={(isChecked) => handleSwitchToggle(type.id, isChecked)}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
            <MeuBotao loading={loading} />
          </Panel>
        )}
      </form>
    </>
  );
};

export default EditTypesRegistration;
